module.exports = __webpack_public_path__ + "static/media/img-msg-secret@2x.053edf72.png";